/**
 * Axios instance without auth interceptors for public endpoints.
 */

import axios from 'axios';
import { API_URL } from './axios';

const unauthenticatedApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false,
});

export default unauthenticatedApi;
